import React from 'react';

const ActionBadge = ({children = 'Action à réaliser'}) => (
    <span
        style={{
            display: 'inline-block',
            backgroundColor: '#0437FF',
            color: '#fff',
            padding: '0.25rem 0.6rem',
            borderRadius: '0.25rem',
            fontWeight: 600,
            fontSize: '0.875rem',
            lineHeight: 1.2,
        }}
    >
        {children}
    </span>
);

export default ActionBadge;
